module.exports = __webpack_public_path__ + "static/media/Gotham Rounded Bold.640c207c.woff";